export default __webpack_public_path__ + "static/media/right-arrow.696dc98b.svg";